import React from "react";
import axios from "axios";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useIntl } from 'react-intl';

const CheckFilter = ({filter, values, search, handleChange}) => {

    const intl = useIntl();

    const onChange = (e) => {
        const { value } = e.target;
        handleChange(filter.name, value);
    }

    const [ filterList, setFilterList ] = React.useState();

    const [currentFilterList, setCurrentFilterList] = React.useState();

    const [filterSearch, setFilterSearch] = React.useState(null);

    React.useEffect(() => {
        if(!currentFilterList && filterList){
            setCurrentFilterList(filterList);
        }
        if(!filterList){
            if(filter.src){
                axios.get(filter.src)
                .then(result => {
                    setFilterList(result.data);
                })
                .catch(err => {
                    console.log(err);
                })
            } else {
                setFilterList(filter.options); // Set options manually
            }

        }
    }, [filterList]);

    React.useEffect(() => {
        if(filterSearch === null){
            search != null && setFilterSearch(search);
        }
        else{
            if(filterList){
                const newFilters = filterList.filter(f => f.fullName ? f.fullName.toLowerCase().includes(filterSearch.toLowerCase()) : f.name.toLowerCase().includes(filterSearch.toLowerCase()));
                setCurrentFilterList(newFilters);
            }
        }
    }, [filterSearch]);


    search != null && filterSearch != null && filterSearch != search && setFilterSearch(search);


    return (
        <React.Fragment>
            {
                currentFilterList && values && currentFilterList.map((fil, index) => {
                return(
                <FormControlLabel
                    key={`checkbox_option_${index}`}
                    label={fil.value ? intl.formatMessage({ id: fil.value }) : fil.fullName ? fil.fullName : fil.name}
                    control={<Checkbox size="normal" value={fil.id} checked={values.includes(fil.id)} onChange={onChange} />}
                />
                )
                }
                )
            }
        </React.Fragment>
    );
}

export default CheckFilter;
